import {
	Euler,
	MathUtils,
	Quaternion,
	Vector3
} from "three/build/three.module";


var MixedControls = function (object, domElement) {

	if (domElement === undefined) {

		console.warn('MixedControls: The second parameter "domElement" is now mandatory.');
		domElement = document;

	}

	var scope = this;

	this.object = object;
	this.object.rotation.reorder('YXZ');

	this.domElement = domElement;

	this.enabled = true;

	this.movementSpeed = 1.0;
	this.moveForward = false;

	this.deviceOrientation = {};
	this.screenOrientation = 0;

	this.alphaOffset = 0; // radians

	if (this.domElement !== document) {

		this.domElement.setAttribute('tabindex', - 1);

	}

	var onDeviceOrientationChangeEvent = function (event) {

		scope.deviceOrientation = event;

	};

	var onScreenOrientationChangeEvent = function () {

		scope.screenOrientation = window.orientation || 0;

	};

	// The angles alpha, beta and gamma form a set of intrinsic Tait-Bryan angles of type Z-X'-Y''

	var setObjectQuaternion = function () {

		var zee = new Vector3(0, 0, 1);

		var euler = new Euler();

		var q0 = new Quaternion();

		var q1 = new Quaternion(- Math.sqrt(0.5), 0, 0, Math.sqrt(0.5)); // - PI/2 around the x-axis

		return function (quaternion, alpha, beta, gamma, orient) {

			euler.set(beta, alpha, - gamma, 'YXZ'); // 'ZXY' for the device, but 'YXZ' for us

			quaternion.setFromEuler(euler); // orient the device

			quaternion.multiply(q1); // camera looks out the back of the device, not the top

			quaternion.multiply(q0.setFromAxisAngle(zee, - orient)); // adjust for screen orientation

		};

	}();

	this.onMouseUp = function (event) {

		event.preventDefault();
		event.stopPropagation();

		this.moveForward = !this.moveForward;

	};

	this.connect = function () {

		onScreenOrientationChangeEvent(); // run once on load

		// iOS 13+

		if (window.DeviceOrientationEvent !== undefined && typeof window.DeviceOrientationEvent.requestPermission === 'function') {

			window.DeviceOrientationEvent.requestPermission().then(function (response) {

				if (response === 'granted') {

					window.addEventListener('orientationchange', onScreenOrientationChangeEvent, false);
					window.addEventListener('deviceorientation', onDeviceOrientationChangeEvent, false);

				}

			}).catch(function (error) {

				console.error('MixedControls: Unable to use DeviceOrientation API:', error);

			});

		} else {

			window.addEventListener('orientationchange', onScreenOrientationChangeEvent, false);
			window.addEventListener('deviceorientation', onDeviceOrientationChangeEvent, false);

		}

		scope.enabled = true;

	};

	this.disconnect = function () {

		window.removeEventListener('orientationchange', onScreenOrientationChangeEvent, false);
		window.removeEventListener('deviceorientation', onDeviceOrientationChangeEvent, false);

		scope.enabled = false;

	};

	this.update = function () {

		if (scope.enabled === false) return;

		var device = scope.deviceOrientation;

		if (device) {

			var alpha = device.alpha ? MathUtils.degToRad(device.alpha) + scope.alphaOffset : 0; // Z

			var beta = device.beta ? MathUtils.degToRad(device.beta) : 0; // X'

			var gamma = device.gamma ? MathUtils.degToRad(device.gamma) : 0; // Y''

			var orient = scope.screenOrientation ? MathUtils.degToRad(scope.screenOrientation) : 0; // O

			setObjectQuaternion(scope.object.quaternion, alpha, beta, gamma, orient);

		}


	};

	this.updateMove = function (delta) {
		//		var targetPosition = new Vector3();

		if (this.enabled === false) return;
		var actualMoveSpeed = delta * this.movementSpeed;

		if (this.moveForward) {
			this.object.translateZ(- actualMoveSpeed);
		}

		//			var position = this.object.position;
		//			targetPosition.add(position);
	};

	this.dispose = function () {

		scope.disconnect();

		this.domElement.removeEventListener('mouseup', _onMouseUp, false);

	};

	var _onMouseUp = bind(this, this.onMouseUp);

	this.domElement.addEventListener('mouseup', _onMouseUp, false);

	function bind(sc, fn) {

		return function () {

			fn.apply(sc, arguments);

		};

	}

	this.connect();

};

export { MixedControls };
